<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
      <h4>{{ this.data.add === true ? "ADD NEW" : "UPDATE" }} ITEM</h4>
      <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
        <!-- NAME -->
        <vs-input label="Name" v-model="name" class="mt-5 w-full" name="item-name" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-name')">{{ errors.first('item-name') }}</span>

        <vs-input label="Alias" v-model="alias" class="mt-5 w-full" name="item-alias" v-validate="'required'" />
        <span class="text-danger text-sm" v-show="errors.has('item-alias')">{{ errors.first('item-alias') }}</span>

        <div class="popup-item">
          <h4>Content</h4>
          <p>Add html code for display.</p>
          <vue-editor :editorOptions="editorSettings" v-model="content"></vue-editor>
        </div>
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import vSelect from 'vue-select'
import { VueEditor, Quill } from 'vue2-editor'
import htmlEditButton from 'quill-html-edit-button'
import {mapActions} from 'vuex'

Quill.register({
  'modules/htmlEditButton': htmlEditButton
})
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    VuePerfectScrollbar,
    'v-select': vSelect,
    VueEditor
  },
  data () {
    return {
      id: null,
      name: '',
      alias: '',
      content: '',
      is_readonly: 0,
      is_required: 0,
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      editorSettings: {
        modules: {
          htmlEditButton: {
            prependSelector: 'div#myelement' // a string used to select where you want to insert the overlayContainer, default: null (appends to body),
          }
        }
      }
    }
  },
  mounted () {

  },
  watch: {
    isSidebarActive (val) {
      if (!val) return

      if (this.data.add === true) {
        this.initValues()
        this.$validator.reset()
      } else {
        const { name, id, alias, content } = JSON.parse(JSON.stringify(this.data))
        this.id = id
        this.name = name
        this.alias = alias
        this.content = content
        this.initValues()
      }
      // Object.entries(this.data).length === 0 ? this.initValues() : { this.dataId, this.dataName, this.dataCategory, this.dataOrder_status, this.dataPrice } = JSON.parse(JSON.stringify(this.data))
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any() && this.name && this.alias && this.content
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    ...mapActions('liveCity', ['updateLiveCity', 'saveLiveCity']),
    initValues () {
      if (this.data.id) return
      this.id = null
      this.name = ''
      this.alias = ''
      this.content = ''
      this.is_required = 0
      this.is_readonly = 0
    },
    async submitData () {
      this.$validator.validateAll().then(async result => {
        this.$vs.loading()
        if (result) {
          const obj = {
            cityId: this.id,
            name: this.name,
            alias: this.alias,
            cityContent: this.content
          }
          let liveCity = {}
          if (this.id) {
            liveCity = await this.updateLiveCity({payload: obj})
          } else {
            liveCity = await this.saveLiveCity({payload: obj})
          }
          this.$vs.notify({
            title: 'Success',
            text: liveCity.message,
            iconPack: 'feather',
            icon: 'icon-check',
            color: 'success'
          })
          this.$emit('closeSidebar')
          this.initValues()
          this.$vs.loading.close()
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .add-new-data-sidebar {
    ::v-deep .vs-sidebar--background {
      z-index: 52010;
    }

    ::v-deep .vs-sidebar {
      z-index: 52010;
      width: 800px;
      max-width: 90vw;

      .img-upload {
        margin-top: 2rem;

        .con-img-upload {
          padding: 0;
        }

        .con-input-upload {
          width: 100%;
          margin: 0;
        }
      }
    }
  }

  .scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
  }
</style>
